<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.5884 1.87982L14.6913 4.12982C14.5185 4.22957 14.3933 4.39366 14.3409 4.58497L13.8733 6.3341L12.1937 7.30385L11.8187 6.65433C11.6117 6.2958 11.1527 6.17282 10.7941 6.37982L4.94848 9.75482C1.36703 11.8226 0.135536 16.4186 2.20329 20C4.27104 23.5815 8.86703 24.8129 12.4485 22.7452C15.6649 20.8882 17.0192 17.018 15.7161 13.5909L21.4298 6.23738C21.6176 5.99561 21.6401 5.66563 21.4879 5.40193L19.6129 2.15433C19.4059 1.7958 18.9469 1.67282 18.5884 1.87982ZM10.5735 19.4976C8.7795 20.5334 6.48663 19.919 5.45088 18.125C4.41513 16.331 5.0295 14.0382 6.82348 13.0024C8.61745 11.9667 10.9103 12.581 11.9461 14.375C12.9818 16.169 12.3674 18.4619 10.5735 19.4976Z"
            fill="#0FA2B7"
        />
    </svg>
</template>
<script>
export default {
    data() {
        return {};
    },
};
</script>
